import {view} from '@sail/ui/deprecated';
import {MetaRow} from '@stripe-internal/conversations-ui';
import {FormattedMessage, defineMessages} from 'react-intl';

const messages = defineMessages({
  signedInAs: {
    id: 'mse_inline_data.universal_help_sign_in.signed_in_as',
    description: 'Text for signed_in_as label.',
    defaultMessage: 'Signed in as {merchantName}',
  },
});

export const SignedInAsLabel = ({merchantName}: {merchantName: string}) => {
  return (
    <>
      <view.div data-testid="uh-sign-in-signed-in-as-label">
        <MetaRow>
          <view.div
            css={{
              margin: 'small',
            }}
          >
            <FormattedMessage
              {...messages.signedInAs}
              values={{
                merchantName,
              }}
            />
          </view.div>
        </MetaRow>
      </view.div>
    </>
  );
};
